import _extends from "@babel/runtime-corejs2/helpers/extends";
import * as React from 'react';
import { Field } from 'redux-form';
var FormField = function FormField(props) {
  return (
    /*#__PURE__*/
    // $FlowFixMe[incompatible-type]
    React.createElement(Field, _extends({
      id: props.id || props.name
    }, props))
  );
};
export default FormField;